var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wrapper"},[_c('app-LeftNavigation'),_vm._v(" "),_c('section',{staticClass:"main_right_sidesec"},[(_vm.pageLoader)?_c('div',{staticClass:"loader-info"},[_c('img',{attrs:{"src":require("../../../static/prism_admin/images/prism_loader.gif")}})]):_vm._e(),_vm._v(" "),_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d27f326","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prism_admin/index.vue
// module id = null
// module chunks = 